module.exports = __webpack_public_path__ + "static/img/静止.3801d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/电力工程车/静止.png
// module id = ahRy
// module chunks = 76